/**
 * Home-hero bird animation controller.
 *
 * The bird is an alpha video perched on the hero rectangle; its first and
 * last frames are the static perched pose. Once the hero illustration has
 * loaded, wait a second, play the animation once, then replay it once a
 * minute. Between plays the video rests on the perched pose.
 */
(function () {
  var INITIAL_DELAY_MS = 1000;
  var REPLAY_INTERVAL_MS = 60000;

  var hero = document.querySelector('.home-hero');
  if (!hero) return;

  var bird = hero.querySelector('.home-hero__bird');
  if (!bird || typeof bird.play !== 'function') return;

  // Respect reduced motion: leave the bird on its static perched pose.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  function playOnce() {
    try {
      bird.currentTime = 0;
    } catch (e) {
      /* ignore — not seekable yet; play() still starts from 0 */
    }
    var promise = bird.play();
    if (promise && promise.catch) {
      promise.catch(function () {
        /* ignore playback restrictions; the poster/last frame keeps showing */
      });
    }
  }

  bird.addEventListener('ended', function () {
    bird.currentTime = 0; // rest on the perched pose, ready for the next play
  });

  function start() {
    window.setTimeout(function () {
      playOnce();
      window.setInterval(playOnce, REPLAY_INTERVAL_MS);
    }, INITIAL_DELAY_MS);
  }

  // Wait for the hero illustration before the first play.
  var image = hero.querySelector('.home-hero__image');
  if (!image || image.complete) {
    start();
  } else {
    image.addEventListener('load', start, { once: true });
    image.addEventListener('error', start, { once: true });
  }
})();
